import React from 'react';
import './Footer.css'


const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
<footer className="footer bg-light ">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* About Section */}
            <div className="col-md-6 mb-4">
              <div className="footer-column footer-about">
                <h3 className="footer-title">En casa origen</h3>
                <p className="footer-about-text">Vive la experiencia perfecta: hospédate en una cabaña o disfruta de un día al aire libre. ¡Hablemos!</p>
              </div>
            </div>

            {/* Contact Section */}
            <div className="col-md-6">
              <div className="footer-column">
                <h3 className="footer-title">Contacto</h3>
                <p className="footer-about-text">Zona norte de Cartagena km 18 vía Cartagena - Barranquilla, Colombia<br/></p>

<p className="footer-about-text"> En el corregimient
  o de Arroyo de piedra</p>
                <p className="footer-about-text"><a href="tel:+573188959559" className="text-decoration-none">+57 318 895 9559</a></p>
                <p className="footer-about-text"><i className="bi bi-envelope-fill me-2"></i>info@casaorigenecohotel.com</p>
                <div className="mt-3 footer-about-social-list">
                  <i className="bi bi-instagram"></i>
                  <i className="bi bi-facebook"></i>
                  <i className="bi bi-pinterest"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom bg-dark text-white py-3">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <p>© Copyright {currentYear} by <a href="/" className="text-decoration-none text-light">casaorigenecohotel.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
